
import CustomLinkButton from 'GeneralComponents/CustomLinkButton';
import ControlBtns from './Carousel_ControlBtns';
import { LinkItem } from 'Interfaces/general.interface';

type Props = {
    dir: string;
    componentId: string;
    isMiniNews: boolean;
    isTablet: boolean;
    pauseNews: () => void;
    isAutoplayActive: boolean;
    link: LinkItem;
    show: boolean;
}

const CarouselPaginationMenu: React.FC<Props> = ({ dir, show, link, componentId, isMiniNews, isTablet, pauseNews, isAutoplayActive, }) => {

    if (!show) return null;

    return <div className={`pagination-menu pagination-menu-${componentId} ${link.url ? "center-link" : ""}`}>

        {
            link.url &&
            < CustomLinkButton
                pageUrl={""}
                link={link}
                isBtn={false}
                btnClass={""}
                linkClass="link-btn txt-pallete-color for-mobile"
                dir={dir}
                linkIcon={true}
                charLimit={25}
            />
        }

        <ControlBtns
            componentId={componentId}
            dir={dir}
            isAutoplayActive={isAutoplayActive}
            isMiniNews={isMiniNews}
            isTablet={isTablet}
            pauseNews={pauseNews}
        />

    </div>
}

export default CarouselPaginationMenu;